import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import requester from 'utils/requester';
import api from 'config/api';
import { DEFAULT_PIN } from 'config';
import { getIsUsingDefaultPin } from 'reducers/profile/selectors';
import { setIsUsingDefaultPin } from 'actions/profile';

const useCheckDefaultPin = () => {
  const dispatch = useDispatch();
  const isUsingDefaultPin = useSelector(getIsUsingDefaultPin);

  const check = useCallback(async () => {
    // No need to perform request if we already know that user don't use default pin
    if (isUsingDefaultPin === false) return false;

    let status;

    try {
      await requester({
        method: 'post',
        url: `${api.host}${api.endpoints.checkPin}`,
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
        },
        data: { pin: DEFAULT_PIN },
      });
      status = true;
    } catch (error) {
      status = false;
    }
    dispatch(setIsUsingDefaultPin(status));

    return status;
  }, [dispatch, isUsingDefaultPin]);

  return check;
};

export default useCheckDefaultPin;
